(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-topbar"] && !Shopify.designMode) return;
  try {
    
class NwTopbarRotator extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.nw-topbar__message'));
    this.index = 0;
    this.hovered = false;
    this.focused = false;
    this.editorPaused = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.addEventListener('mouseenter', () => { this.hovered = true; this.play(); }, options);
    this.addEventListener('mouseleave', () => { this.hovered = false; this.play(); }, options);
    this.addEventListener('focusin', () => { this.focused = true; this.play(); }, options);
    this.addEventListener('focusout', event => {
      if (!this.contains(event.relatedTarget)) { this.focused = false; this.play(); }
    }, options);
    this.addEventListener('shopify:block:select', event => {
      const index = this.items.findIndex(item => item.dataset.blockId === event.detail?.blockId);
      if (index < 0) return;
      this.editorPaused = true;
      this.show(index);
      this.play();
    }, options);
    this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.play(); }, options);
    this.motion.addEventListener('change', () => this.play(), options);
    document.addEventListener('visibilitychange', () => this.play(), options);
    this.show(0);
    this.play();
  }
  show(index) {
    this.index = index;
    this.items.forEach((item, position) => {
      const active = position === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', String(!active));
      item.inert = !active;
    });
  }
  play() {
    clearInterval(this.timer);
    if (this.items.length < 2 || this.dataset.autoplay !== 'true' || this.hovered || this.focused || this.editorPaused || this.motion.matches || document.hidden) return;
    const speed = Math.max(2, Math.min(10, Number(this.dataset.speed) || 4));
    this.timer = setInterval(() => this.show((this.index + 1) % this.items.length), speed * 1000);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    this.events?.abort();
  }
}
if (!customElements.get('nw-topbar-rotator')) customElements.define('nw-topbar-rotator', NwTopbarRotator);

  } catch(e) { console.error(e); }
})();
})();
